import { createFileRoute, Navigate } from '@tanstack/react-router';
import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { SettingsLayout } from '@/containers/settings/settings-layout.component';

export const Route = createFileRoute('/settings/')({
  component: SettingsRoute,
});

function SettingsRoute() {
  // Settings opens on the first item of its nav.
  return (
    <AuthCheck>
      <Head heading='Settings' />
      <SettingsLayout>
        <Navigate to='/settings/account' replace />
      </SettingsLayout>
    </AuthCheck>
  );
}
